import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import type { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import type { Observable } from 'rxjs';
import { firstValueFrom } from 'rxjs';

import { WidgetsService } from 'components/organisms/widgets-loader/widgets.service';
import { WIDGETS_CONFIG } from 'components/widgets/widgets-config';
import { HTTP_ERROR_HANDLER_SERVICE } from 'src/services/http-error-handler/entities/const';
import type { IHttpErrorHandlerService } from 'src/services/http-error-handler/entities/types';

import { BaseResolver } from './base-resolver';
import type { ILandingPageWidget } from '../layouts/entities/types';

@Injectable()
export class PresetPreviewViewResolverService extends BaseResolver implements Resolve<ILandingPageWidget[] | null> {
    private readonly platformId = inject(PLATFORM_ID);
    private readonly widgetsService = inject(WidgetsService);
    protected readonly httpErrorHandlerService: IHttpErrorHandlerService;

    constructor() {
        const httpErrorHandlerService = inject<IHttpErrorHandlerService>(HTTP_ERROR_HANDLER_SERVICE);

        super(httpErrorHandlerService);

        this.httpErrorHandlerService = httpErrorHandlerService;
    }

    public resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        if (isPlatformBrowser(this.platformId)) {
            window.parent.postMessage('get_preview_data', '*');
            return new Promise((resolve) => {
                window.addEventListener('message', async ({ data }) => {
                    if (data.type && data.type === 'preview_data') {
                        const widgets = (data?.widgets ?? []) as ILandingPageWidget[];
                        await firstValueFrom(
                            this.widgetsService.resolveWidgetsFromPage(
                                { widgets, layout: { name: 'full' } },
                                WIDGETS_CONFIG
                            )
                        );
                        resolve(widgets);
                    }
                });
            });
        }

        return Promise.resolve(null);
    }
}
